import React, {Component} from 'react';
import './App.css';
import Header from './Header/Header'
import Main from "./Main/Main";
import Skills from "./Skills/Skills";
import Projects from "./Projects/Projects";
import Contact from "./Contact/Contact";

import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import Toolbar from '@material-ui/core/Toolbar';
import FavoriteIcon from '@material-ui/icons/Favorite';
import NavigationIcon from '@material-ui/icons/Navigation';
import { Container, Button, Link } from 'react-floating-action-button'
import {Icon} from "@material-ui/core";



class App extends Component {
    state = {
        show: true,
        showButton: false
    }

    handleClick = () => {
        // this.setState({
        //     show: false
        // })
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    handleScroll() {
        const y = window.pageYOffset || document.documentElement.scrollTop;
        if (y > 300) {
            this.setState({showButton: true});
        } else {
            this.setState({showButton: false});
        }
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll.bind(this));
    }


    render() {
        return (
            <div className="App">
                <Header/>
                <Main/>
                <Skills/>
                <Projects/>
                <Contact/>
                <Container className={this.state.showButton ? 'show' : 'hide'}>
                    <Fab style={{backgroundColor:"#8ca3bc", color:"white",width:"40px",height:"40px"}} onClick={ () =>this.scrollToTop()}>
                        <NavigationIcon style={{width:"20px",height:"20px"}}/>
                    </Fab>
                </Container>
            </div>
        );
    }
}

export default App;
